import GraduateForm from './GraduateForm';

export default GraduateForm;
